export default __webpack_public_path__ + "static/media/optionMenuIcon.7ff39cd8.svg";